import { useState, useRef, useEffect } from 'react'
import Geosuggest from '@ubilabs/react-geosuggest'
import Pin from '@assets/pin.svg'
import styles from './RegularLocation.module.css'
import { Header } from 'semantic-ui-react'
import {
  getAddressCountry,
  getAddressState,
  getAreaForCountry,
} from '@src/helpers'

export default function SmallLocationInput({
  defaultValue,
  clear,
  errorText,
  loading,
  label,
  disabled,
  style,
  placeholder,
  handleUpdate,
  scriptLoaded,
}) {
  const [focus, setFocus] = useState(false)
  const inputEl = useRef(null)

  useEffect(() => {
    if (clear) {
      inputEl.current.clear()
    }
  }, [clear])

  const handleSubmit = (e) => {
    e.preventDefault()
    return false
  }

  const onSuggestSelect = (value, data) => {
    inputEl.current.blur()

    const country = getAddressCountry(value)
    const territory = getAddressState(value)

    const location = {
      formatted_address: value?.description,
      regions: {
        region: `${country}_${territory}`.toLowerCase(),
        area: getAreaForCountry(country),
        country: country ? country.toLowerCase() : '',
      },
      coordinate: {
        lat: value?.location?.lat,
        lon: value?.location?.lng,
      },
    }
    handleUpdate(location)
  }

  const onFocus = () => setFocus(true)
  const onBlur = () => setFocus(false)

  if (!scriptLoaded) {
    return (
      <div
        className={`${styles.locationField} ${
          focus && styles.locationFieldFocused
        }`}
      >
        <Pin className={styles.pin} />
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} style={style} autoComplete="false">
      <div className={styles.wrap}>
        {(label || errorText) && (
          <div className={styles.textHeader}>
            {label && (
              <Header as="h4" className={styles.label}>
                {label}
              </Header>
            )}
            {errorText && <div className={styles.error}>{errorText}</div>}
          </div>
        )}
        {disabled ? (
          <div
            className={`${styles.locationField} ${styles.disabledLocationField}`}
          >
            <Geosuggest
              placeholder={placeholder}
              autoComplete="nope"
              className={styles.disabledInputFieldSearch}
              suggestsClassName={styles.suggestList}
              onSuggestSelect={onSuggestSelect}
              initialValue={defaultValue?.formatted_address}
              types={['(cities)']}
              disabled={true}
              onFocus={onFocus}
              onBlur={onBlur}
              ref={inputEl}
            />
            <Pin className={styles.pin} />
          </div>
        ) : (
          <div
            className={`${styles.locationField} ${
              focus && styles.locationFieldFocused
            }`}
          >
            <Geosuggest
              placeholder={placeholder}
              autoComplete="nope"
              className={styles.inputFieldSearch}
              suggestsClassName={styles.suggestList}
              onSuggestSelect={onSuggestSelect}
              initialValue={defaultValue?.formatted_address}
              types={['(cities)']}
              onFocus={onFocus}
              onBlur={onBlur}
              ref={inputEl}
            />
            <Pin className={styles.pin} />
          </div>
        )}
      </div>
    </form>
  )
}
